export const STREETS_BROWSING_H3_RES: number = parseInt(process.env.REACT_APP_STREETS_BROWSING_H3_RES);
